import React from 'react'
import { Modal, Button } from 'react-bootstrap'

interface ShortcutsModalProps {
  show: boolean
  onHide: () => void
}

type ShortcutItem = { keys: string; action: string }

const SECTION_SPACING_CLASS = 'mb-3'

const globalShortcuts: ShortcutItem[] = [
  { keys: 'Enter', action: 'Submit current annotations/review' },
  { keys: 'Shift + N', action: 'Next image' },
  { keys: 'Shift + P', action: 'Previous image' },
  { keys: 'Ctrl/Cmd + Z', action: 'Undo' },
  { keys: 'Ctrl/Cmd + Y', action: 'Redo' },
  { keys: 'Tab / Shift + Tab', action: 'Select next/previous box (auto-zooms/pans to selection)' },
  { keys: 'Delete', action: 'Delete selected box' },
  { keys: 'Esc', action: 'Cancel OBB creation (if in progress)' },
  { keys: '+ / =', action: 'Zoom in' },
  { keys: '- / _', action: 'Zoom out' },
  { keys: 'Ctrl/Cmd + +', action: 'Pan up' },
  { keys: 'Ctrl/Cmd + -', action: 'Pan down' },
  { keys: 'Alt + +', action: 'Pan right' },
  { keys: 'Alt + -', action: 'Pan left' },
]

const bboxShortcuts: ShortcutItem[] = [
  { keys: 'Arrow keys', action: 'Move 1 px (hold Shift: 5 px)' },
  { keys: 'Alt + Arrow Left/Right', action: 'Scale horizontally (centered)' },
  { keys: 'Alt + Arrow Up/Down', action: 'Scale vertically (centered)' },
]

const obbShortcuts: ShortcutItem[] = [
  { keys: 'Arrow keys', action: 'Move 1 px (hold Shift: 5 px)' },
  { keys: 'Ctrl/Cmd + Arrow Left/Right/Up/Down', action: 'Rotate ±1° (hold Shift: ±5°)' },
  { keys: 'Alt + Arrow Left/Right', action: 'Scale along the box’s long edge (u axis)' },
  { keys: 'Alt + Arrow Up/Down', action: 'Scale along the box’s short edge (v axis)' },
]

const predictionsShortcuts: ShortcutItem[] = [
  { keys: 'A', action: 'Accept selected prediction' },
  { keys: 'R', action: 'Reject selected prediction' },
]

const Section: React.FC<{ title: string; items: ShortcutItem[] }> = ({ title, items }) => (
  <div className={SECTION_SPACING_CLASS}>
    <h6 className="text-white mb-2">{title}</h6>
    <div className="list-group list-group-flush">
      {items.map((item, idx) => (
        <div
          key={`${title}-${idx}`}
          className="list-group-item bg-dark text-white d-flex justify-content-between align-items-start px-0"
          style={{ borderColor: '#2b2b2b' }}
        >
          <div className="me-3 text-nowrap">
            <span className="badge bg-secondary text-white">{item.keys}</span>
          </div>
          <div className="flex-grow-1 text-break">{item.action}</div>
        </div>
      ))}
    </div>
  </div>
)

const ShortcutsModal: React.FC<ShortcutsModalProps> = ({ show, onHide }) => {
  return (
    <Modal
      className="create-project-modal"
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header className={'bg-primary text-white'} closeButton>
        <Modal.Title>Keyboard Shortcuts</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-white">
        <Section title="Global" items={globalShortcuts} />
        <Section title="When a BBox is selected" items={bboxShortcuts} />
        <Section title="When an OBB is selected" items={obbShortcuts} />
        <Section title="Predictions Review" items={predictionsShortcuts} />
      </Modal.Body>
      <Modal.Footer className="bg-dark text-white d-flex justify-content-end">
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ShortcutsModal
